<div class="bg__container">
  <ul class="bg__squares">
    <li *ngFor="let item of items"></li>
  </ul>
</div>
